import React, { useCallback, useEffect, useRef, useState } from 'react';

import moment from 'moment';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import NCModal from './NCModal';
import utils from '../../Helpers/FunctionsHelpers';
import IssueClosureModalDocExpireModal from '../Custom/IssueClosureModalDocExpireModal';
import IssuesClosureModal from '../Custom/IssuesClosureModal';
import MassTreatmentModal from '../Custom/MassTreatmentModal';
import { SystemTypeIdDocsExpiration } from '../Enums/MaintenanceTypeIds';
import Table from '../Table/Table';

import {
  getChild,
  getGestaoIssuesList,
  getWarningList,
  listClientActiveSystemsTypes,
  listInspectionTypes,
} from '../Api/Api';

export default function Main() {
  const $ = require('jquery');
  const intervalMinutes = 1;

  const { clientId } = useParams();
  const { register, handleSubmit } = useForm();
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);
  const [systemMaintenance, setSystemMaintenance] = useState([]);
  const [warningList, setWarningList] = useState([]);
  const [systemType, setSystemType] = useState([]);
  const [inspectionTypes, setInspectionTypes] = useState([]);
  const [showClosureModal, setShowClosureModal] = useState(false);
  const [showClosureDocExpireModal, setShowClosureDocExpireModal] =
    useState(false);
  const [client_id, setClientId] = useState();
  const selectedNCsRef = useRef([]);
  const [selectedNCs, setSelectedNCs] = useState([]);
  const [showMassTreatmentModal, setShowMassTreatmentModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    clientId: clientId,
    systemId: null,
    ini: null,
    fim: null,
    prior: null,
    inspectionType: null,
  });

  const columns = [
    {
      title: 'NC',
      data: 'system_maintenance_id',
      className: 'text-center align-middle',
    },
    {
      title: 'Unidade',
      data: 'info_name',
      className: 'text-center align-middle',
    },
    {
      title: 'Sistema',
      data: 'system_type_name',
      className: 'text-center align-middle',
    },
    {
      title: 'Problema',
      data: 'system_maintenance_text',
      className: 'text-center align-middle',
      width: '40%',
    },
    {
      title: 'Ação',
      data: 'system_maintenance_action',
      className: 'text-center align-middle',
      width: '30%',
    },
    {
      title: 'Prioridade',
      data: 'maintenance_type_priority',
      className: 'text-center align-middle',
      createdCell: function (cell, cellData) {
        if (cellData) {
          if (cellData === 'Crítico') {
            $(cell).addClass('criticals');
          } else if (cellData === 'Urgente') {
            $(cell).addClass('urgente');
          }
        }
      },
    },
    {
      title: 'Data de criação',
      data: 'system_maintenance_created',
      className: 'text-center align-middle',
    },
    {
      title: 'Prazo sugerido',
      data: 'system_maintenance_expiration',
      className: 'text-center align-middle',
    },
    {
      title: 'Modalidade da vistoria',
      data: 'inspection_type_name',
      className: 'text-center align-middle',
    },
    {
      title: 'Prazo documental',
      data: 'document_expiration',
      className: 'text-center align-middle',
      render: function (data) {
        if (data) {
          return data;
        } else {
          return '-';
        }
      },
    },
    {
      title: 'Responsabilidade',
      data: 'is_responsable_s2u',
      className: 'text-center align-middle',
      render: (data, x, row) => {
        let badgeColor = 'secondary';
        let badgeTitle = 'Cliente';

        if (data === '1') {
          badgeColor = 'danger';
          badgeTitle = 'SAFETY2U';
        }

        return `<span class="badge rounded-pill bg-${badgeColor} pr-7" title=${badgeTitle}>&nbsp;</span>`;
      },
    },
    {
      title: 'Ações',
      data: null,
      className: 'text-center align-middle',
    },
  ];

  const actionButtons = (row) => {
    const anySelected = selectedNCs.length > 0;
    return (
      <>
        <button
          className={`btn btn-sm btn-primary m-2 treating ${anySelected ? 'disabled' : ''}`}
          onClick={(e) => {
            if (anySelected) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            handleShow(row);
          }}
          disabled={anySelected}
          title={
            anySelected
              ? 'Desmarque os itens selecionados para habilitar este botão'
              : 'Tratativas'
          }
        >
          Tratativas
        </button>
        <button
          type="btn"
          className="btn btn-sm btn-danger px-3"
          onClick={() => handleEnd(row)}
        >
          Encerrar
        </button>
      </>
    );
  };

  const listSystemType = useCallback(async () => {
    const chl = await getChild(clientId);
    if (chl) {
      const res = await listClientActiveSystemsTypes(chl.data[0].client_id);
      if (res.data) {
        setSystemType(res.data);
      }
    }
  }, [clientId]);

  const loadInspectionTypes = useCallback(async () => {
    const res = await listInspectionTypes();
    if (res.data) {
      setInspectionTypes(res.data);
    }
  }, []);

  const handleShow = async (row) => {
    sessionStorage.setItem('gestao_mainNcRow', JSON.stringify(row));

    await setSystemMaintenance([]);
    setShow(true);
    await setSystemMaintenance(row);
    const rst = await getWarningList(row.system_maintenance_id);
    if (rst) {
      setWarningList(rst.data);
    }
  };

  const loadGrid = useCallback(() => {
    const sessionSearch = sessionStorage.getItem('gestao_searchJson');

    let searchFilters = filters;
    if (sessionSearch) {
      searchFilters = JSON.parse(sessionSearch);
    }

    populateList(searchFilters);
  }, [filters]);

  const handleClose = () => {
    sessionStorage.removeItem('gestao_mainNcRow');

    loadGrid();

    setShow(false);
  };

  const handleClosureModal = async () => {
    setShowClosureModal(true);
  };

  const handleCloseClosureModal = () => {
    loadGrid();
    setShowClosureModal(false);
  };

  const handleModalDocExpire = async () => {
    setShowClosureDocExpireModal(true);
  };

  const handleCloseModalDocExpire = () => {
    loadGrid();
    setShowClosureDocExpireModal(false);
  };

  const handleEnd = async (row) => {
    await setSystemMaintenance(row);
    setClientId(row.client_id);
    if (SystemTypeIdDocsExpiration.includes(row.maintenance_type_id)) {
      handleModalDocExpire();
    } else {
      handleClosureModal();
    }
  };

  const handleSelectionChange = (selectedIds) => {
    const selectedData = list.filter((nc) =>
      selectedIds.includes(nc.system_maintenance_id)
    );

    const simplifiedData = selectedData.map((nc) => ({
      system_maintenance_id: nc.system_maintenance_id,
      system_type_id: nc.system_type_id,
    }));

    setSelectedNCs(simplifiedData);
  };

  const handleShowMassTreatmentModal = (selectedIds) => {
    let dataToUse;

    if (selectedIds && selectedIds.length > 0) {
      dataToUse = list
        .filter((nc) => selectedIds.includes(nc.system_maintenance_id))
        .map(({ system_maintenance_id, system_type_id }) => ({
          system_maintenance_id,
          system_type_id,
        }));
    }

    if (dataToUse.length > 0) {
      const hasControlePrazos = dataToUse.some(
        (nc) => nc.system_type_id === '15'
      );
      const hasOtherSystems = dataToUse.some(
        (nc) => nc.system_type_id !== '15'
      );

      if (hasControlePrazos && hasOtherSystems) {
        Swal.fire(
          'OPS!',
          "Não é possível realizar a tratativa em massa enquanto houverem NCs do tipo 'Controle de Prazos' misturados com outros tipos de sistemas na seleção",
          'error'
        );
        return;
      }

      setSelectedNCs(dataToUse);
      setTimeout(() => {
        setShowMassTreatmentModal(true);
      }, 50);
    }
  };

  const handleCloseMassTreatmentModal = () => {
    setShowMassTreatmentModal(false);
  };

  const handleMassTreatmentSuccess = () => {
    setSelectedNCs([]);
    setIsLoading(true);
    setList([]);
    loadGrid();
  };

  const populateList = async (data) => {
    setList([]);
    setIsLoading(true);
    const res = await getGestaoIssuesList(data);
    if (res) {
      setList(res.data);
    } else {
      setList(undefined);
    }
    setIsLoading(false);
  };

  const setSearch = async (data) => {
    if (data.systemId === '') {
      data.systemId = null;
    }
    if (data.ini === '') {
      data.ini = null;
    }
    if (data.fim === '') {
      data.fim = null;
    }
    if (data.inspectionType === '') {
      data.inspectionType = null;
    }

    setFilters({ ...filters, ...data });
    sessionStorage.setItem('gestao_searchJson', JSON.stringify(data));
    populateList(data);
  };

  useEffect(() => {
    selectedNCsRef.current = selectedNCs;
  }, [selectedNCs]);

  useEffect(() => {
    utils.manageSidebar('close');

    const getList = async () => {
      const sessionSearch = sessionStorage.getItem('gestao_searchJson');

      if (sessionSearch) {
        const parsedSearch = JSON.parse(sessionSearch);

        if (parsedSearch.clientId !== clientId) {
          sessionStorage.removeItem('gestao_searchJson');
        }
      }

      populateList(filters);
    };

    getList();
    listSystemType();
    loadInspectionTypes();

    const interval = setInterval(
      () => {
        if (selectedNCsRef.current.length > 0) {
          return;
        }
        if (!show) {
          const row = JSON.parse(sessionStorage.getItem('gestao_mainNcRow'));
          if (row) {
            handleShow(row);
          }

          loadGrid();
        }
      },
      1000 * 60 * intervalMinutes
    );

    return () => {
      sessionStorage.removeItem('gestao_mainNcRow');
      clearInterval(interval);
    };
  }, [listSystemType, filters, loadGrid, clientId, show]);

  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <div className="card search">
            <div className="card-body">
              <form onSubmit={handleSubmit(setSearch)}>
                <div className="row">
                  <input
                    type="number"
                    hidden
                    value={clientId}
                    {...register('clientId', { required: true })}
                  />
                  <div className="col-sm-12 col-md-3">
                    <label>Sistema</label>
                    <select
                      className="form-select"
                      {...register('systemId', { required: false })}
                    >
                      <option value="">Todos</option>
                      {systemType.length
                        ? systemType.map((item, index) => {
                            return (
                              <option key={index} value={item.system_type_id}>
                                {item.system_type_name}
                              </option>
                            );
                          })
                        : ''}
                    </select>
                  </div>
                  <div className="col-sm-12 col-md-2">
                    <label>Data Inicio</label>
                    <input
                      type="date"
                      className="form-control"
                      {...register('ini', { required: false })}
                    />
                  </div>
                  <div className="col-sm-12 col-md-2">
                    <label>Data Fim</label>
                    <input
                      type="date"
                      className="form-control"
                      {...register('fim', { required: false })}
                    />
                  </div>
                  <div className="col-sm-12 col-md-2">
                    <label>Prioridade</label>
                    <select
                      className="form-select"
                      {...register('prior', { required: false })}
                    >
                      <option value="0">Todas</option>
                      <option value="1">Baixa</option>
                      <option value="2">Crítico</option>
                      <option value="3">Urgente</option>
                    </select>
                  </div>
                  <div className="col-sm-12 col-md-2">
                    <label>Modalidade da vistoria</label>
                    <select
                      className="form-select"
                      {...register('inspectionType', { required: false })}
                    >
                      <option value="">Todos</option>
                      {inspectionTypes.length
                        ? inspectionTypes.map((item, index) => {
                            return (
                              <option key={index} value={item.id}>
                                {item.description}
                              </option>
                            );
                          })
                        : ''}
                    </select>
                  </div>
                  <div className="col-md-1 d-flex align-items-end">
                    <button className="btn btn-secondary w-100" type="submit">
                      {isLoading ? (
                        <div
                          className="spinner-border spinner-border-sm text-light"
                          role="status"
                        ></div>
                      ) : (
                        'Filtrar'
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <section className="section">
          <div className="col-12">
            <div className="card">
              <div className="card-header">Lista de Não Conformidades</div>
              <div className="card-body scrollBase">
                <Table
                  data={list}
                  columns={columns}
                  btnColumn={11}
                  actBtns={actionButtons}
                  keepState={true}
                  selectable={true}
                  useCheckboxes={true}
                  onSelectionChange={handleSelectionChange}
                  selectedRows={selectedNCs}
                  onBulkAction={handleShowMassTreatmentModal}
                />
              </div>
            </div>
          </div>
        </section>
        <IssuesClosureModal
          isOpen={showClosureModal}
          systemMaintenance={systemMaintenance}
          onClose={handleCloseClosureModal}
          client_id={client_id}
        />
        <IssueClosureModalDocExpireModal
          show={showClosureDocExpireModal}
          close={handleCloseModalDocExpire}
          system_maintenance_id={systemMaintenance?.system_maintenance_id}
          system_maintenance_created={
            systemMaintenance?.system_maintenance_created
          }
          client_id={client_id}
        />
        <NCModal
          show={show}
          handleClose={handleClose}
          userId={sessionStorage.getItem('gestao_userId')}
          systemMaintenance={systemMaintenance}
          warningList={warningList}
          setShow={setShow}
        />
        <MassTreatmentModal
          show={showMassTreatmentModal}
          handleClose={handleCloseMassTreatmentModal}
          selectedNCs={selectedNCs}
          onSuccess={handleMassTreatmentSuccess}
        />
      </main>
    </>
  );
}
